import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class ConstantsService {

  private baseUrl: string = 'https://livecharts.thebrighthouse.nl/';
  private chartsPath: string = 'chart/';
  private authPath: string = 'auth/';
  private authDocument: string = 'login.json';
  private indexPath: string = 'index/';
  private indexDocument: string = 'charts.json';

  public colors = {
    'geel': '#ffcb04',
    'geelG': '#d3a808',
    'oranje': '#f8991c',
    'oranjeG': '#cb7317',
    'rood': '#f05323',
    'roodG': '#b23815',
    'roze': '#af1f8e',
    'rozeG': '#750465',
    'donkerblauw': '#0058a9',
    'donkerblauwG': '#002361',
    'lichtblauw': '#00b5dd',
    'lichtblauwG': '#0089a8',
    'grasgroen': '#39b54a',
    'grasgroenG': '#008738',
    'appelgroen': '#a6ce39',
    'appelgroenG': '#81a32b',
  };

  public colorMapping = {
    'rood': ['rood', 'geel', 'roze', 'oranje', 'appelgroen', 'grasgroen', 'donkerblauw', 'lichtblauw'],
    'blauw': ['lichtblauw', 'donkerblauw', 'grasgroen', 'appelgroen', 'oranje', 'roze', 'geel', 'rood']
  };

  public colorLists: any;

  public chartTypes: string[] = ['pie', 'banner'];

  constructor(
  ) {
    this.colorLists = _.reduce(this.colorMapping, (acc, value, key) => {
      let colors = _.map(value, (c) => this.colors[c]);
      acc[key] = colors;
      return acc;
    }, {});
  }

  public getBaseURL() {
    return this.baseUrl;
  }

  public getAuthUrl() {
    let url = this.baseUrl + this.authPath + this.authDocument;
    // console.log(url);
    return url;
  }

  public getIndexUrl(endpoint: string) {
    let url = this.baseUrl + endpoint + '/' + this.indexPath + this.indexDocument;
    // console.log(url);
    return url;
  }

  public getChartURL(endpoint: string, chart: string) {
    let url = this.baseUrl + endpoint + '/' + this.chartsPath + chart;
    // console.log(url);
    return url;
  }

  public getColors() {
    return this.colors;
  }

  public getColorMapping() {
    return this.colorMapping;
  }

  public getColorList(color: string) {
    return this.colorLists[color];
  }

  public getColorLists() {
    return this.colorLists;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/constants.service.ts